import React from 'react';
import { useQueries } from '@magoosh/gre/app/queries';
import ContextualLink from '@magoosh/gre/app/contextual_link';
import style from '../side_bar/style.module.scss';
import { paths } from 'config/path_helpers';
import moment from 'moment-timezone';
import LockIcon from '../../assets/lock_icon.svg';

export const LiveClassesWidget: React.FC = () => {
  const query = useQueries().liveClassesWidgetQuery();
  
  return (
    <div className={style.section}>
      <h4>
        <strong>Live Classes</strong>
      </h4>
      {query.isSuccess && query.data.upcoming.map((liveClass, idx) => {
        const dateTime = moment.utc(liveClass.dateTime).tz(moment.tz.guess());

        return (
          <div key={idx} className={style.sectionItem}>
            <p>
              {liveClass.name}
              <br />
              <small>
                {dateTime.isSame(moment(), 'day') ? 'Today' : dateTime.format('dddd, MMMM D')} at{' '}
                {dateTime.format('LT z')}
                <br />
                {liveClass.isLocked && (
                  <span className="d-flex align-items-center">
                    <br />
                    <img src={LockIcon} alt="lock" style={{ width: '15px' }} />
                    This class starts after your trial ends.
                  </span>
                )}
              </small>
            </p>
            {liveClass.isLocked ? (
              <ContextualLink href={paths.plans()} target="_blank" style={{ color: style.brandSecondary }}>
                <strong>Upgrade</strong>
              </ContextualLink>
            ) : (
              <ContextualLink href={paths.liveClasses()} style={{ color: style.brandSecondary }}>
                <strong>Register</strong>
              </ContextualLink>
            )}
          </div>
        );
      })}
      <ContextualLink href={paths.liveClasses()}>See All Classes</ContextualLink>
    </div>
  );
};

export default LiveClassesWidget;
